module.exports = __webpack_public_path__ + "img/icon-saldo-restante.a1adfec7.svg";